import { FC, memo } from 'react';
import { Helmet } from 'react-helmet';

const AdTag: FC = () => {
  return (
    <>
      <Helmet>
        {/* Yahoo */}
        <script async src="https://s.yimg.jp/images/listing/tool/cv/ytag.js" />
        <script async type="application/javascript">
          {`
          // B：コンバージョン測定補完機能タグ
          window.yjDataLayer = window.yjDataLayer || [];
          function ytag() { yjDataLayer.push(arguments); }
          ytag({"type":"ycl_cookie"});
          `}
        </script>
        <script async type="application/javascript">
          {`
          // C：YSSCVタグ
          ytag({
            "type": "yss_conversion",
            "config": {
              "yahoo_conversion_id": "1001203426",
              "yahoo_conversion_label": "OFC0CI3xu98CEMHGnaQB",
              "yahoo_conversion_value": "0"
            }
          });
          `}
        </script>
        <script async type="application/javascript">
          {`
          // C'：YDACVタグ
          ytag({
            "type":"yjad_conversion",
            "config":{
              "yahoo_ydn_conv_io": "S545d8wbLUhAVZMf3HJ0MA..",
              "yahoo_ydn_conv_label": "JQ5V366IDXM5REZMJKC833656",
              "yahoo_ydn_conv_transaction_id": "",
              "yahoo_ydn_conv_value": "0"
            }
          });
          `}
        </script>
        <script async type="application/javascript">
          {`
          // D：YDAサイトジェネラルタグ&リタゲタグ
          window.yjDataLayer = window.yjDataLayer || [];
          function ytag() { yjDataLayer.push(arguments); }
          ytag({
            "type":"yjad_retargeting",
            "config":{
              "yahoo_retargeting_id": "R1GJ57QNET",
              "yahoo_retargeting_label": "",
              "yahoo_retargeting_page_type": "",
              "yahoo_retargeting_items":[
                {item_id: '', category_id: '', price: '', quantity: ''}
              ]
            }
          });
          `}
        </script>

        {/* Global site tag (gtag.js) */}
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
        `}</script>

        {/* Twitter universal website tag code */}
        <script async type="application/javascript">{`
          !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
          },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
          a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
          // Insert Twitter Pixel ID and Standard Event data below
          twq('init','o6grd');
          twq('track','PageView');
        `}</script>

        {/* LINE Tag Base Code */}
        <script async type="application/javascript">{`
          (function(g,d,o){
            g._ltq=g._ltq||[];g._lt=g._lt||function(){g._ltq.push(arguments)};
            var h=location.protocol==='https:'?'https://d.line-scdn.net':'http://d.line-cdn.net';
            var s=d.createElement('script');s.async=1;
            s.src=o||h+'/n/line_tag/public/release/v1/lt.js';
            var t=d.getElementsByTagName('script')[0];t.parentNode.insertBefore(s,t);
              })(window, document);
          _lt('init', {
            customerType: 'lap',
            tagId: '9f8fd830-0e72-4571-8cfa-d13b3d8fc76b'
          });
          _lt('send', 'pv', ['9f8fd830-0e72-4571-8cfa-d13b3d8fc76b']);
        `}</script>
      </Helmet>

      {/* Facebook Pixel Code */}
      <img
        alt=""
        height="1"
        width="1"
        style={{ display: 'none' }}
        src="https://www.facebook.com/tr?id=428845568264726&ev=PageView&noscript=1"
      />
    </>
  );
};

export default memo(AdTag);
